<template>
  <CHeader class="bg-white shadow-sm sticky-top">
    <CContainer fluid>
      <div class="d-flex justify-content-between align-items-center py-2">
        <!-- Logo -->
        <div class="d-flex align-items-center">
          <router-link to="/" class="d-flex align-items-center text-decoration-none">
            <CIcon name="cil-user" size="xl" class="text-marketing-primary mr-2"/>
            <span class="h4 mb-0 font-weight-bold text-marketing-dark">Niagaku</span>
          </router-link>
        </div>

        <!-- Desktop Navigation -->
        <div class="d-none d-md-flex align-items-center">
          <router-link to="/features" class="text-marketing-gray-700 font-weight-medium px-3 text-decoration-none">Features</router-link>
          <router-link to="/pricing" class="text-marketing-gray-700 font-weight-medium px-3 text-decoration-none">Pricing</router-link>
          <router-link to="/calculators" class="text-marketing-gray-700 font-weight-medium px-3 text-decoration-none">Free Tools</router-link>
          <router-link to="/guides" class="text-marketing-gray-700 font-weight-medium px-3 text-decoration-none">Guides</router-link>
        </div>

        <!-- Desktop Auth Buttons -->
        <div class="d-none d-md-flex align-items-center">
          <!-- Show different buttons based on auth state -->
          <template v-if="isAuthenticated">
            <CButton class="btn-marketing-primary" variant="outline" to="/tenants/dashboard" style="border-color: var(--marketing-primary); color: var(--marketing-primary);">
              <CIcon name="cil-grid" class="mr-1"/>
              Go to Dashboard
            </CButton>
          </template>
          <template v-else>
            <CButton color="light" to="/login" class="mr-2">Login</CButton>
            <CButton class="btn-marketing-accent" to="/signup">
              Start Free Trial
            </CButton>
          </template>
        </div>

        <!-- Mobile menu button -->
        <div class="d-md-none">
          <CButton
            color="light"
            size="sm"
            @click="mobileMenuOpen = !mobileMenuOpen"
            aria-label="Toggle menu"
          >
            <CIcon :name="mobileMenuOpen ? 'cil-x' : 'cil-menu'" size="lg"/>
          </CButton>
        </div>
      </div>

      <!-- Mobile menu -->
      <CCollapse :show="mobileMenuOpen" class="d-md-none">
        <div class="py-3">
          <router-link to="/features" class="d-block py-2 text-marketing-gray-700 text-decoration-none" @click.native="mobileMenuOpen = false">
            Features
          </router-link>
          <router-link to="/pricing" class="d-block py-2 text-marketing-gray-700 text-decoration-none" @click.native="mobileMenuOpen = false">
            Pricing
          </router-link>
          <router-link to="/calculators" class="d-block py-2 text-marketing-gray-700 text-decoration-none" @click.native="mobileMenuOpen = false">
            Free Tools
          </router-link>
          <router-link to="/guides" class="d-block py-2 text-marketing-gray-700 text-decoration-none" @click.native="mobileMenuOpen = false">
            Guides
          </router-link>

          <hr class="my-3">

          <template v-if="isAuthenticated">
            <CButton class="btn-marketing-primary" variant="outline" to="/tenants/dashboard" block @click.native="mobileMenuOpen = false" style="border-color: var(--marketing-primary); color: var(--marketing-primary);">
              <CIcon name="cil-grid" class="mr-1"/>
              Go to Dashboard
            </CButton>
          </template>
          <template v-else>
            <CButton color="light" to="/login" block class="mb-2" @click.native="mobileMenuOpen = false">
              Login
            </CButton>
            <CButton class="btn-marketing-accent" to="/signup" block @click.native="mobileMenuOpen = false">
              Start Free Trial
            </CButton>
          </template>
        </div>
      </CCollapse>
    </CContainer>
  </CHeader>
</template>

<script>
export default {
  name: 'MarketingHeader',
  data() {
    return {
      mobileMenuOpen: false
    }
  },
  computed: {
    isAuthenticated() {
      // Check if user is authenticated using window.auth
      return window.auth && window.auth.token && window.auth.user
    }
  },
  watch: {
    '$route'() {
      // Close mobile menu on route change
      this.mobileMenuOpen = false
    }
  }
}
</script>

<style scoped>
/* Additional header styles if needed */
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}
</style>
